/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
/* eslint-disable react/require-default-props */
import React from 'react';
import {
    object, shape, arrayOf, string, array,
} from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Grid from '@material-ui/core/Grid';
import mbpLogger from 'mbp-logger';

import MobileBanners from './MobileBanners';
import { determineLanguagePrefixPath } from '../../../../../../../helpers/determineInternationalizationPath';
import GiftBlockBottom from '../DesktopGiftBlock/Partials/GiftBlockBottom';

const styles = (theme) => ({
    mainContainer: {
        width: '100%',
        maxWidth: '1440px',
        margin: 'auto',
    },
    topLogo: {
        '& h1': {
            color: theme.palette.flowerGift.topLogoText.color,
            fontSize: '18px',
            textAlign: 'center',
            padding: '5px 20px',
        },
    },
    bannerContainer: {
        margin: '0 8px 18px 8px',
    },
});

/* eslint-disable react/prop-types */ // TODO refactor as part of PWA-2848, render f(x) pattern doesnt like proptypes
const MobileGiftBlock = ({ classes, block }) => {
    const key = Object.keys(block)[0];

    const renderHeader = () => {
        // Retrive header data for mobile
        const { header: { copy = '' } } = block;
        if (!copy) {
            mbpLogger.logDebug({
                message: `No banner_group returned for Mobile Gift Block Headers block \n copy data ${copy}`,
                module: 'mbp-pwa-ui',
            });
            return null;
        }
        return (
            <Grid container>
                <Grid item xs={12}>
                    <div className={classes.topLogo}>
                        <h1>
                            {copy}
                        </h1>
                    </div>
                </Grid>
            </Grid>
        );
    };

    const renderBanners = () => {
        const { banners: { banner = [] } = {} } = block;
        // TODO PWA-2848 comes with mobile & desktop, should convert query to using viewport to avoid
        const [banner_group = ''] = banner ? banner.filter((viewport) => viewport.name === 'Mobile Banners') : [];
        const bannerAcross = banner_group?.banners_across;
        if (!banner_group) {
            mbpLogger.logDebug({
                message: `No banner_group returned for Mobile Gift Block Banners block \n banner_group data ${banner_group}`,
                module: 'mbp-pwa-ui',
            });
            return null;
        }
        return (
            <div className={classes.bannerContainer}>
                <Grid container>
                    {banner_group?.banner_group?.map((bannerList) => {
                        const { link: { title, href  }, image: { url }  } = bannerList;
                        return (
                            <MobileBanners key={`${title}`} title={title} link={determineLanguagePrefixPath(href)} imgUrl={url} imgTitle={title} bannerAcross={bannerAcross} />
                        );
                    }) }
                </Grid>
            </div>
        );
    };

    const renderBottomBanner = () => {
        const { bottom: { bottom_banner = [] } = {} } = block || null;
        const { image = '' } = bottom_banner?.[1] || null;
        if (!image) {
            mbpLogger.logDebug({
                message: `No bottom_banner returned for Mobile Gift Block Bottom block \n image data ${image}`,
                module: 'mbp-pwa-ui',
            });
            return null;
        }
        return (
            <div className={classes.bottomContainer}>
                <Grid container>
                    <GiftBlockBottom image={image} />
                </Grid>
            </div>
        );
    };

    switch (key) {
        case 'header':
            return renderHeader();

        case 'banners':
            return renderBanners();

        case 'bottom':
            return renderBottomBanner();

        default:
            mbpLogger.logError({
                message: `Unrecognized page_block for Template Collection Sem Page Mobile Gift Block. \n Please remove from ContentStack \n Block name key = ${key}, Block Data = ${block}`,
                module: 'mbp-pwa-ui',
            });
            return null;
    }
};

MobileGiftBlock.propTypes = {
    classes: object.isRequired,
    block: shape({
        header: shape({
            copy: string,
        }),
        banners: shape({
            banner: arrayOf(shape({
                banner_group: array,
            })),
        }),
    }).isRequired,
};
export default withStyles(styles)(MobileGiftBlock);
